import styled from "styled-components";

export const DottedBorder = styled.div`
	display: flex;
	align-items: center;

	top: 20px;
	left: 20px;

	width: 20px;

	cursor: pointer;
	z-index: 1;

	border-top: 2px solid #0071bc;
	border-bottom: 2px solid #0071bc;

	& > span {
		display: block;

		width: 100%;
		height: 2px;

		background-color: #0071bc;
		margin-top: 2px;
		margin-bottom: 2px;
	}
`;
